import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "LIBRARY/Components/User/UserIssuedResources/userIssuedResorces.css";
import LibraryApiCall from 'LibraryApiCall';
import { Component } from 'react';
import Pagination from 'react-js-pagination';
import { connect } from 'react-redux';
import ViewEResourceDetails from './viewEResourceDetails';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import { toast } from 'react-toastify';

class StudentEResource extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            pageIndex: 1,
            limit: 10,

            //VARIABLE TO GET E-RESOURCE  DATA LIST
            eResourceDataLoading: false,
            eResourceData: {},
            totalEResourceItem: 0,
            eResourceSortedIdArray: [],

            linkedInstituteArray: {},
            linkedIidArray: [],

            viewSingleResources: false,
            singleResourceData: {},

            loadingFilterResourceCategory: false,
            filterResourceCategoryData: [],
            academicYearSequence: [],
            academicYearList: [],

            // filter variables
            eResourceTitle: "",
            eResourceAuthor: "",
            eResourceCateogry: "",
            eResourceSearchKeyword: "",
            eResourceType: "",
            eResourceFromDate: "",
            eResourceToDate: "",
            eResourceAcademicYear: "",
            eResourceSortByTitle: "ASC",

            //STATE FOR ORDER BY
            orderByStatistics: [
                { name: "Title Ascending Order (A-Z)", value: 'ASC' },
                { name: "Title Descending Order (Z-A)", value: 'DESC' }
            ],
        }
    }

    componentDidMount() {
        // this.GetAssignedInstituteList();
        this.library_getEResources();
        this.apiFilterLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.apiCallToGetAcademicYearList();
    }

    //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                let linkedInstituteData = apiResult.linkedInstituteData;
                let linkedIidArrayValue = apiResult.linkedIidArray;

                this.setState({
                    linkedInstituteArray: linkedInstituteData,
                    linkedIidArray: linkedIidArrayValue
                });

                // this.library_getEResources();
                // this.apiFilterLibraryResourceCategoryListWithBasicDetails();  // resource category
                // this.apiCallToGetAcademicYearList();
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    library_getEResources = async () => {
        this.setState({ eResourceDataLoading: true })

        let requestData = {
            "instituteId": config.institute_id,
            // "iidArray": this.state.linkedIidArray,
            "searchKeyword": this.state.eResourceSearchKeyword,
            "filerTitle": this.state.eResourceTitle,
            "filterAuthor": this.state.eResourceAuthor,
            "filterResourceType": this.state.eResourceType?.value,
            "filterResourceCategory": this.state.eResourceCateogry?.value,
            "filterDepartment": "",
            "filterAcademicYear": this.state.eResourceAcademicYear,
            "filterSubject": "",
            "filterFromDate": this.state.eResourceFromDate,
            "filterToDate": this.state.eResourceToDate,
            "filterSortBy": this.state.eResourceSortByTitle,
            "pageIndex": this.state.pageIndex,
            "limit": this.state.limit
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getEResources',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_getEResources();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            eResourceData: apiResult.data,
                            totalEResourceItem: apiResult.Total,
                            eResourceSortedIdArray: apiResult.sortedIdArray,
                            eResourceDataLoading: false
                        });
                    } else {
                        this.setState({
                            eResourceData: {},
                            totalEResourceItem: 0,
                            eResourceSortedIdArray: [],
                            eResourceDataLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        eResourceData: {},
                        eResourceDataLoading: false,
                        eResourceSortedIdArray: []
                    });
                }

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    //FILTER API CALL TO GET get resource category List 
    apiFilterLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingFilterResourceCategory: true,
        })

        let requestData = {
            iid: config.institute_id,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryList',
            requestData,
            "/api/library/learner.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiFilterLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    filterResourceCategoryData: formattedData,
                    loadingFilterResourceCategory: false,
                })
            } else {
                this.setState({
                    loadingFilterResourceCategory: false,
                })
            }
        }
    }

    // METHOD TO GET ACADEMIC YEAR LIST
    apiCallToGetAcademicYearList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAcademicYearListObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                // Map the apiData to the desired format
                const formattedData = Object.keys(apiResult).map(key => ({
                    yearID: key,
                    yearName: apiResult[key].year_text
                }));

                this.setState({
                    academicYearArray: formattedData,
                    academicYearList: apiResult,
                    academicYearSequence: jsonResponse.APIResult.sortedIdArray,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting academic year list. Please try again later.'
                });
            }
        }
    }

    library_addEResourceView = async (resourceData) => {
        let requestData = {
            instituteId: config.institute_id,
            userId: config.studentId,
            userRole: "learner",
            eResourceId: resourceData?.uniqueId
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_addEResourceView',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse?.expired) {
            setTimeout(() => {
                this.library_addEResourceView(resourceData);
            }, 1000);
            return;
        }

        if (jsonResponse?.success) {
            let apiResult = jsonResponse.APIResult;

            // FINAL FIX — match your old PHP/iframe logic
            if (apiResult.errorCode !== "403") {

                this.setState({
                    viewSingleResources: true,
                    singleResourceData: resourceData
                });

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: apiResult.message
                });
            }

        } else {
            this.setState({
                successModal: true,
                successModalType: 'error',
                successMessage: 'Something went wrong. Please try again later.'
            });
        }
    };


    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber }, () => {
            this.library_getEResources();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value }, () => {
            this.library_getEResources();
        });
    }

    // VIEW attachment
    viewSingleResourceDetails = (resourceData) => {
        this.library_addEResourceView(resourceData);
    };

    // resource filter title on change
    handleResourceTitleChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", eResourceTitle: event.target.value });
    };
    handleResourceTitleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.library_getEResources();
        }
    };

    // resource filter author on change
    handleResourceAuthorChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", eResourceAuthor: event.target.value });
    };
    handleResourceAuthorKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.library_getEResources();
        }
    };

    // resource filter search keyword on change
    handleResourceSearchKeywordChange = (event) => {
        this.setState({ eResourceSearchKeyword: event.target.value });
    };

    handleOrderByChange = (value) => {
        this.setState({ eResourceSortByTitle: value, limit: this.state.limit, pageIndex: this.state.pageIndex }, () => {
            this.library_getEResources();
        })
    }

    // Advance Filter Model - Method to open modal
    advanceFilterModal = () => {
        this.setState({
            advanceFilterModal: true,
        })
    }

    closeAdvanceFilterModal = () => {
        this.setState({
            advanceFilterModal: false,
            eResourceTitle: "",
            eResourceAuthor: "",
            eResourceCateogry: "",
            eResourceSearchKeyword: "",
            eResourceType: "",
            eResourceFromDate: "",
            eResourceToDate: "",
            eResourceAcademicYear: "",
            eResourceSortByTitle: "ASC",
        })
    }

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            <div className={this.state.advanceFilterModal ? "modal fade show" : "modal fade"} id="modalContainer">
                <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '50VW' }}>
                    <div className="modal-content modalBulkContent">
                        {/* Modal Header */}
                        <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                            <h6 className="modal-title">
                                {/* <img src={advanceFilter} alt="Advanced Filter" style={{ marginRight: '10px' }} /> */}
                                <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                                Advanced Filter
                            </h6>
                            <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => this.closeAdvanceFilterModal()} style={{ cursor: "pointer" }} />

                        </div>

                        {/* Modal Content */}
                        <div className="custom-form-body" style={{ padding: '10px', overflowY: 'auto', maxHeight: '60vh' }}>
                            {/* Form Group: Search Keyword & Type */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Search Keyword
                                    </label>
                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                        <img
                                            src={searchPng}
                                            style={{
                                                position: 'absolute',
                                                left: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#ccc',
                                                backgroundColor: 'white',
                                                width: '18px',
                                                height: '18px',
                                                zIndex: 1,
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control formControlAutoTask"
                                            id="resourceTitleFilterID"
                                            placeholder="Enter Search Keyword"
                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                            value={this.state.eResourceSearchKeyword} // Bind value to state
                                            onChange={this.handleResourceSearchKeywordChange} // Handle input changes
                                        />
                                    </div>
                                    <p style={{ marginLeft: "5px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get e-resource list filter result.</p>

                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Type
                                    </label>
                                    <Select
                                        name="SeriesAdvFilter"
                                        options={[
                                            { value: "PDF", label: "PDF" },
                                            { value: "Doc", label: "Doc" },
                                            { value: "Audio", label: "Audio" },
                                            { value: "Video", label: "Video" },
                                            { value: "URL", label: "URL" },
                                        ]}
                                        onChange={(event) => {
                                            this.setState({
                                                eResourceType: event || [], // Handle empty selection
                                            })
                                        }}
                                        value={this.state.eResourceType}
                                        placeholder="Select Type"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexDirection: 'column', // Make selected options stack vertically
                                                marginBottom: '5px', // Adjust space between selected options
                                            }),
                                            multiValueLabel: (base) => ({
                                                ...base,
                                                padding: '5px 10px', // Add padding to the labels for better readability
                                                whiteSpace: 'normal', // Allow text wrapping if needed
                                            }),
                                            multiValueRemove: (base) => ({
                                                ...base,
                                                display: 'none', // Optionally hide the remove button if you don't need it
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: "13px",
                                                fontWeight: 400,
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>

                            {/* Form Group: From Date & To Date */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        From Date
                                    </label>
                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                        <input
                                            type="date"
                                            className="form-control"
                                            style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                            placeholder="Select From Date"
                                            value={this.state.eResourceFromDate}
                                            onChange={(event) => {
                                                const newFromDate = event.target.value || "";
                                                this.setState(
                                                    {
                                                        eResourceFromDate: newFromDate,
                                                        // Reset eResourceToDate if it's before the new from date
                                                        eResourceToDate:
                                                            this.state.eResourceToDate && newFromDate && this.state.eResourceToDate < newFromDate
                                                                ? ""
                                                                : this.state.eResourceToDate,
                                                        pageIndex: 1, limit: "10"
                                                    });
                                            }}
                                        />
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        To Date
                                    </label>
                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                        <input
                                            type="date"
                                            className="form-control"
                                            style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                            placeholder="Select To Date"
                                            value={this.state.eResourceToDate}
                                            onChange={(event) => {
                                                const newToDate = event.target.value || "";

                                                // Only validate if user actually selected a date
                                                if (newToDate && this.state.eResourceFromDate && newToDate < this.state.eResourceFromDate) {
                                                    toast.error('To Date cannot be earlier than From Date.', {
                                                        position: "top-right",
                                                        autoClose: 2000,
                                                        hideProgressBar: false,
                                                        closeOnClick: true,
                                                        pauseOnHover: true,
                                                        draggable: true,
                                                        progress: undefined,
                                                    });
                                                    return;
                                                }
                                                this.setState(
                                                    { eResourceToDate: newToDate, pageIndex: 1, limit: "10" });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Form Group: Academic year */}
                            <div className="form-group row" style={{ marginBottom: '15px' }}>
                                <div className="col-md-6">
                                    <label className="vm_custom_body5" color='#454E52' htmlFor="SeriesAdvFilter">
                                        Academic Year
                                    </label>
                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                        <Select
                                            name="AcademicYearFilter"
                                            placeholder="Select Academic Year"
                                            options={
                                                Object.keys(this.state.academicYearList).length > 0
                                                    ? this.state.academicYearSequence.map((yearId) => {
                                                        let year = this.state.academicYearList[yearId];
                                                        return {
                                                            value: yearId,
                                                            label: year.year_text,
                                                        };
                                                    })
                                                    : []
                                            }
                                            value={
                                                this.state.eResourceAcademicYear
                                                    ? {
                                                        value: this.state.eResourceAcademicYear,
                                                        label: this.state.academicYearList[this.state.eResourceAcademicYear]?.year_text || "",
                                                    }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                this.setState({
                                                    eResourceAcademicYear: selectedOption ? selectedOption.value : "",
                                                });
                                                // Optional: call your existing handler if needed
                                                this.handleFilterAcdyearChange(selectedOption ? selectedOption.value : "");
                                            }}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    minHeight: 42,
                                                    height: "auto",
                                                    fontSize: "13px",
                                                    fontWeight: 400,
                                                    borderRadius: "7px",
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#999" },
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    fontSize: "13px",
                                                    fontWeight: 400,
                                                    backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                                                    color: state.isSelected ? "#333" : "#555",
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: "#808080",
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "#333",
                                                }),
                                            }}
                                            menuPortalTarget={document.body}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer" style={{ padding: '20px 25px' }}>
                            <button
                                className="btn custom-btn"
                                style={{ fontSize: '14px', borderRadius: '7px' }}
                                // borderColor: '#0465AC !important'
                                onClick={() => {
                                    this.closeAdvanceFilterModal();
                                }}
                            >
                                Clear
                            </button>
                            <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                                this.library_getEResources();
                                this.setState({ advanceFilterModal: false })
                            }}>
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // CLEAR ALL FILTER
    handleClearAllResourceFilter = () => {
        this.setState({
            limit: "10", pageIndex: 1, eResourceTitle: "", eResourceAuthor: "", eResourceCateogry: "", eResourceSearchKeyword: "", eResourceType: "", eResourceFromDate: "", eResourceToDate: "", eResourceAcademicYear: "", eResourceSortByTitle: "ASC",
        }, () => {
            this.library_getEResources();
        })
    };

    render() {
        return (
            <>
                <RoutingMenu activeScreen="userEresources" />

                <div className="libraryComponents-container pr-3">
                    <div className="pb-4">
                        <div className="pt-1 pb-2">
                            <h4>E-Resources</h4>
                        </div>
                    </div>

                    <div>
                        <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                            <div style={{ width: '100%' }}>
                                {/* filter data form*/}
                                <div className="taskContentRow" style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                        {/* Based On Title */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Title</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceTitleFilterID"
                                                    placeholder="Search by Title "
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.eResourceTitle} // Bind value to state
                                                    onChange={this.handleResourceTitleChange} // Handle input changes
                                                    onKeyPress={this.handleResourceTitleKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>

                                        {/* Based On Author */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Author</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <img
                                                    src={searchPng}
                                                    style={{
                                                        position: 'absolute',
                                                        left: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#ccc',
                                                        backgroundColor: 'white',
                                                        width: '18px',
                                                        height: '18px',
                                                        zIndex: 1,
                                                    }}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control formControlAutoTask"
                                                    id="resourceAuthorFilterID"
                                                    placeholder="Search by Author"
                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px' }}
                                                    value={this.state.eResourceAuthor}
                                                    onChange={this.handleResourceAuthorChange} // Handle input changes
                                                    onKeyPress={this.handleResourceAuthorKeyPress} // Trigger API call on Enter
                                                />
                                            </div>
                                        </div>

                                        {/* Based On Category */}
                                        <div className="filteredInput mb-3  p-1">
                                            <label htmlFor="taskID" className="vm_custom_body5" color='#454E52'>Category</label>
                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                <Select
                                                    name="resourceCategoryFilter"
                                                    options={Object.values(this.state.filterResourceCategoryData).flatMap(item => {
                                                        // Start with the category itself
                                                        const categoryOption = {
                                                            value: item.value,
                                                            label: item.name,
                                                            isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                                        };

                                                        // If the category has subcategories, add those as well
                                                        const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                            value: subCategory.subCategoryId,
                                                            label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                            isDisabled: false, // Subcategory is always enabled
                                                        }));

                                                        // Return the category option followed by the subcategory options
                                                        return [categoryOption, ...subCategoryOptions];
                                                    })}
                                                    value={this.state.eResourceCateogry}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            pageIndex: 1, limit: "10",
                                                            eResourceCateogry: event || [], // Handle empty selection
                                                        }, () => {
                                                            this.library_getEResources();
                                                        })
                                                    }}
                                                    placeholder="Select Category"
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            width: '100%',
                                                            minHeight: 42, // Minimum height for the control area
                                                            height: 'auto', // Allow control to grow dynamically,
                                                            fontSize: "13px",
                                                            fontWeight: 400,
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                        }),
                                                        menuPortal: (base) => ({
                                                            ...base,
                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                        }),
                                                        multiValue: (base) => ({
                                                            ...base,
                                                            display: 'flex',
                                                            flexDirection: 'column', // Make selected options stack vertically
                                                            marginBottom: '5px', // Adjust space between selected options
                                                        }),
                                                        multiValueLabel: (base) => ({
                                                            ...base,
                                                            padding: '5px 10px', // Add padding to the labels for better readability
                                                            whiteSpace: 'normal', // Allow text wrapping if needed
                                                        }),
                                                        multiValueRemove: (base) => ({
                                                            ...base,
                                                            display: 'none', // Optionally hide the remove button if you don't need it
                                                        }),
                                                        option: (base, state) => ({
                                                            ...base,
                                                            fontSize: "13px",
                                                            fontWeight: 400,
                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                            color: state.isSelected ? '#333' : '#555',
                                                        }),
                                                    }}
                                                    menuPortalTarget={document.body}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-end align-items-center" style={{ marginTop: '15px', gap: '10px' }}>
                                        <div className="d-flex ml-2">
                                            <button className="btn outline-button" id='orderByDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style>
                                                <FontAwesomeIcon size='lg' id='orderByDropdownMenu' title="Click to Order By Title" style={{ cursor: 'pointer', color: '#0465AC' }} icon={['fas', 'sort-amount-up-alt']} /></button>
                                            <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='orderByDropdownMenu'>
                                                <div id='orderByDropdown'>
                                                    {
                                                        this.state.orderByStatistics.map((columnInfo, index) => {
                                                            // Determine if the current column is selected
                                                            const isSelected = this.state.eResourceSortByTitle === columnInfo.value;
                                                            return (
                                                                <p className="dropdown-item" style={{
                                                                    display: 'flex', justifyContent: 'space-between', fontSize: '14px', backgroundColor: isSelected ? '#e0f7fa' : 'transparent', // Highlight background if selected
                                                                    color: isSelected ? '#0465AC' : 'black', // Change text color if selected
                                                                    cursor: 'pointer'
                                                                }} key={columnInfo.name}>
                                                                    <span
                                                                        style={{ marginRight: 10, cursor: 'pointer' }}
                                                                        onClick={() => this.handleOrderByChange(columnInfo.value)}  // Trigger the change when name is clicked
                                                                    >
                                                                        {columnInfo.name}
                                                                    </span>
                                                                </p>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {/*Advance Filter Icon*/}
                                        <div id='advanceFilter' className="p-2" style={{ alignItems: "center", display: "flex" }}>
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => this.advanceFilterModal()}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {/* </form> */}
                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get e-resource list filter result.</p>
                                {/* <div className='vm_custom_body5' style={{ marginLeft: "20px" }}>Press "Enter" to get resource list filter result.</div> */}
                            </div>
                        </div>

                        {
                            (this.state.eResourceTitle !== "" || this.state.eResourceAuthor !== "" || this.state.eResourceSearchKeyword !== ""
                                || this.state.pageIndex !== 1 || this.state.limit !== 10 || this.state.eResourceCateogry !== ""
                                || this.state.eResourceType !== "" || this.state.eResourceFromDate !== "" || this.state.eResourceToDate !== ""
                                || this.state.eResourceAcademicYear !== "" || this.state.eResourceSortByTitle !== "ASC"
                            ) &&
                            <div className='filter-apply'>
                                <p className='vm_custom_body5'>Filters are applied.</p>
                                <p className="clear-all vm_custom_body5" onClick={this.handleClearAllResourceFilter}>Clear All</p>
                            </div>
                        }
                    </div>

                    {/* list table */}
                    <div className="col-md-12 px-0 div_table mt-4">
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area" ref={el => this.componentRef = el}>
                                <table className="table table-bordered  vm_libraryReport_table" id="donorListReport">
                                    <thead>
                                        <tr>
                                            <tr className='d-none'>
                                                <th colSpan="7"></th>
                                            </tr>
                                            <th>Sr.No.</th>
                                            <th>Title</th>
                                            <th>Author</th>
                                            <th>Category</th>
                                            <th>Attachment Type</th>
                                            <th>Search Keyword</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.eResourceDataLoading ?
                                                <tr>
                                                    <td colSpan="7">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                this.state.eResourceSortedIdArray?.length > 0 ? (
                                                    this.state.eResourceSortedIdArray.map((periodicalUID, index) => {
                                                        const eResourceItem = this.state.eResourceData[periodicalUID];
                                                        if (!eResourceItem) return null; // Skip if missing

                                                        // Truncate resource category (max 20 chars)
                                                        const resourceCategory =
                                                            eResourceItem?.resourceCategoryName && eResourceItem.resourceCategoryName.length !== 0
                                                                ? eResourceItem.resourceCategoryName.toString()
                                                                : '';

                                                        let subStringCategory = resourceCategory;
                                                        if (subStringCategory.length > 20) {
                                                            subStringCategory = subStringCategory.substring(0, 20) + '...';
                                                        }

                                                        return (
                                                            <tr key={index}>
                                                                <td>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                <td>{eResourceItem?.resourceTitle.charAt(0).toUpperCase() + eResourceItem?.resourceTitle.slice(1) || ""}</td>
                                                                <td>{eResourceItem?.resourceAuthor || ""}</td>
                                                                <td title={resourceCategory}>
                                                                    {subStringCategory}
                                                                </td>
                                                                <td>{eResourceItem?.resourceType || ""}</td>
                                                                <td>{eResourceItem?.searchKeyword}</td>
                                                                <td><a style={{ cursor: "pointer", fontSize: "15px", color: "#0465ac" }} title="Click to view the e-resource details" onClick={() => this.viewSingleResourceDetails(eResourceItem)}>View</a></td>
                                                            </tr>
                                                        )
                                                    })) :
                                                    <tr>
                                                        <td colSpan="11">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {
                            (Object.keys(this.state.eResourceData).length > 0 || Object.keys(this.state.eResourceData).length > this.state.limit) &&
                            <div className='row px-0'>
                                <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                            <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                    <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                        <option value={10}>Entries Per Page 10</option>
                                                        <option value={25}>Entries Per Page 25</option>
                                                        <option value={40}>Entries Per Page 40</option>
                                                        <option value={100}>Entries Per Page 100</option>
                                                        <option value={250}>Entries Per Page 250</option>
                                                    </select>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                            <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                <Pagination
                                                    activePage={this.state.pageIndex}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.totalEResourceItem}
                                                    pageRangeDisplayed={3}
                                                    onChange={this.updatePaginationCount}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                            <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                Total Records : {this.state.totalEResourceItem || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                    </div>

                    {
                        this.state.viewSingleResources &&
                        <ViewEResourceDetails
                            viewSingleResources={this.state.viewSingleResources}
                            onClose={() => this.setState({ viewSingleResources: false, singleResourceData: {} })}
                            ResourceData={this.state.singleResourceData}
                        />
                    }
                    {
                        this.returnAdvanceFilterModelData()
                    }
                </div>
            </>
        )
    }

}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray }
    };
};

export default connect(mapStateToProps)(StudentEResource);